import { useTranslation } from "react-i18next";
import { useRemoveAddonModal } from "@features/Addons/hook/useRemoveAddonModal";
import { ConfirmationModal } from "@common/ConfirmationModal/ConfirmationModal";

interface IParams {
    serviceId: number;
    addonId: number;
    description: string;
    isRemoveAddonModalOpen: boolean;
    onClose(): void;
    getAddonDetails(): void;
}

export const RemoveAddonModal = (props: IParams) => {
    const { serviceId, addonId, description, isRemoveAddonModalOpen, onClose, getAddonDetails } = props;
    const { t } = useTranslation("addons");
    const { handleConfirmRemoveAddon, error, isLoading } = useRemoveAddonModal({ onClose, getAddonDetails });

    return (
        <ConfirmationModal
            error={error}
            isLoading={isLoading}
            isModalOpen={isRemoveAddonModalOpen}
            subtitle={t("ifRemove")}
            title={t("removeAddon", { description })}
            onClose={onClose}
            onContinue={() => handleConfirmRemoveAddon(addonId, serviceId)}
        />
    );
};
